import React from 'react';
import PropTypes from 'prop-types';
import { CircularProgress, makeStyles } from '@material-ui/core';
import Button from '../common/Button';
import { detectAlpha2Country } from '../../../../utils/country';
import { useTranslation } from 'react-i18next';
import appStyles from '../../../../config/appStyles';

const useStyles = makeStyles((theme) => appStyles.withdrawButton(theme));

const WithdrawButton = ({
  label,
  isSubmit = false,
  to = '/myarea/p/withdraw',
  disabled = false,
  onClick,
  loading,
}) => {
  const classes = useStyles();
  const country = detectAlpha2Country();
  const { t } = useTranslation(['components']);

  const handleRedirect = (e) => {
    if (onClick) onClick(e);

    if (!e.defaultPrevented) {
      window.location.assign(`/${country}${to}`);
    }
  };

  if (isSubmit) {
    return (
      <Button
        type="submit"
        className={classes.root}
        disabled={disabled}
        onClick={onClick}>
        {loading ? <CircularProgress color="inherit" size={24} /> : label}
      </Button>
    );
  }

  return (
    <Button
      type="button"
      className={classes.root}
      disabled={disabled}
      onClick={handleRedirect}
      aria-label={label}>
      {t('Withdraw.CTA')}
    </Button>
  );
};

WithdrawButton.propTypes = {
  label: PropTypes.string,
  isSubmit: PropTypes.bool,
  to: PropTypes.string,
  disabled: PropTypes.bool,
  onClick: PropTypes.func,
};

export default WithdrawButton;
